import { render, staticRenderFns } from "./AttendanceSetting.vue?vue&type=template&id=47ccc7bd&scoped=true"
import script from "./AttendanceSetting.vue?vue&type=script&lang=js"
export * from "./AttendanceSetting.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSetting.vue?vue&type=style&index=0&id=47ccc7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccc7bd",
  null
  
)

export default component.exports